// @flow

//
// Lodash
//
import fp from 'lodash/fp';

//
// Duck
//
import { type State } from './reducer';

//
// Selectors
//
const getHttpRequest = (state: State) => state;

export const createHttpRequestSelectors = (localState: (state: any) => State): any => {
    return {
        getHttpRequest: fp.compose(getHttpRequest, localState),
    };
};
